import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import GameSetup from "./GameSetup";
import Lotto from "./Lotto";
import { getGame } from "./gameService";

function App() {
  const [session, setSession] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const gameId = params.get("game");
    if (!gameId) {
      setLoading(false);
      return;
    }
    getGame(gameId)
      .then((game) => {
        if (game) {
          setSession({
            gameId: game.gameId,
            playerCount: game.playerCount,
            initialDrawnNumbers: game.drawnNumbers || [],
          });
        } else {
          clearGameParam();
        }
      })
      .catch(clearGameParam)
      .finally(() => setLoading(false));
  }, []);

  const clearGameParam = () => {
    const url = new URL(window.location);
    url.searchParams.delete("game");
    window.history.replaceState({}, "", url);
  };

  const handleSessionStart = (newSession) => {
    const url = new URL(window.location);
    url.searchParams.set("game", newSession.gameId);
    window.history.pushState({}, "", url);
    setSession(newSession);
  };

  const handleBack = () => {
    clearGameParam();
    setSession(null);
  };

  if (loading) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: "100vh" }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!session) {
    return <GameSetup onSessionStart={handleSessionStart} />;
  }

  return (
    <Lotto
      gameId={session.gameId}
      playerCount={session.playerCount}
      initialDrawnNumbers={session.initialDrawnNumbers}
      onBack={handleBack}
    />
  );
}

export default App;
